import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
`;
export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const RowSpaceAround = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const RowStart = styled.div`
  display: flex;
  justify-content: start;
`;

export const RowEnd = styled.div`
  display: flex;
  justify-content: end;
`;



// WEBPACK FOOTER //
// ./src/components/Common/Row.js